import React from "react";
import {
    Table, Input, Button, Popconfirm, Form,
} from 'antd';

import { RegistorClass } from "../core/ComponentRegistor";

const FormItem = Form.Item;
const EditableContext = React.createContext({});

const EditableRow = ({ form, index, ...props }) => (
    <EditableContext.Provider value={form}>
        <tr {...props} />
    </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component<any> {
    state = {
        editing: false,
    }
    input
    form: any
    toggleEdit = () => {
        const editing = !this.state.editing;
        this.setState({ editing }, () => {
            if (editing) {
                this.input.focus();
            }
        });
    }

    save = (e) => {
        const { record, handleSave } = this.props;
        this.form.validateFields((error, values) => {
            if (error && error[e.currentTarget.id]) {
                return;
            }
            this.toggleEdit();
            handleSave({ ...record, ...values });
        });
    }

    render() {
        const { editing } = this.state;
        const {
            editable,
            dataIndex,
            title,
            record,
            index,
            handleSave,
            ...restProps
        } = this.props;
        return (
            <td {...restProps}>
                {editable ? (
                    <EditableContext.Consumer>
                        {(form: any) => {
                            this.form = form;
                            return (
                                editing ? (
                                    <FormItem style={{ margin: 0 }}>
                                        {form.getFieldDecorator(dataIndex, {
                                            rules: [{
                                                required: true,
                                                message: `${title} is required.`,
                                            }],
                                            initialValue: record[dataIndex],
                                        })(
                                            <Input
                                                ref={node => (this.input = node)}
                                                onPressEnter={this.save}
                                                onBlur={this.save}
                                            />
                                        )}
                                    </FormItem>
                                ) : (
                                        <div
                                            className="editable-cell-value-wrap"
                                            style={{ paddingRight: 24 }}
                                            onClick={this.toggleEdit}
                                        >
                                            {restProps.children}
                                        </div>
                                    )
                            );
                        }}
                    </EditableContext.Consumer>
                ) : restProps.children}
            </td>
        );
    }
}

export class AntEditTable extends React.Component<any,
    {
        data: Array<any>,
        total: number
    }
    > {
    columns
    constructor(props) {
        super(props);
        this.columns = [{
            title: 'name',
            dataIndex: 'name',
            width: '30%',
            editable: true,
        }, {
            title: 'age',
            dataIndex: 'age',
            editable: true
        }, {
            title: 'address',
            dataIndex: 'address',
            editable: true
        }, {
            title: 'operation',
            dataIndex: 'operation',
            render: (text, record) => (
                this.state.data.length >= 1
                    ? (
                        <Popconfirm title="Sure to delete?" onConfirm={() => this.handleDelete(record.key)}>
                            <a href="javascript:;">Delete</a>
                        </Popconfirm>
                    ) : null
            ),
        }];

        this.state = {
            data: [{
                key: '0',
                name: 'Edward King 0',
                age: '32',
                address: 'London, Park Lane no. 0',
            }, {
                key: '1',
                name: 'Edward King 1',
                age: '32',
                address: 'London, Park Lane no. 1',
            }],
            total: 2,
        };
    }

    static getDerivedStateFromProps(nextProps) {
        // Should be a controlled component.
        if ('value' in nextProps) {
            let datas = [...(nextProps.value || [])]
            return {
                data: datas
            };
        }
        return null;
    }

    handleTableChange = (pagination, filters, sorter) => {
        // const pager = { ...this.state.pagination };
        // pager.current = pagination.current;
        // this.setState({
        //     pagination: pager,
        // });
        // this.fetch({
        //     results: pagination.pageSize,
        //     page: pagination.current,
        //     sortField: sorter.field,
        //     sortOrder: sorter.order,
        //     ...filters,
        // });

    }

    handleDelete = (key) => {
        const data = [...this.state.data];
        const newDatas = data.filter(item => item.key !== key)
        this.setState({ data: newDatas });
        const onChange = this.props.onChange;
        if (onChange) {
            // onChange(Object.assign({}, this.state.data, []));
            onChange(Object.assign([], newDatas, []));

        }
    }

    handleAdd = () => {
        const { total, data } = this.state;
        const newData = {
            key: total,
            name: `Edward King ${total}`,
            age: 32,
            address: `London, Park Lane no. ${total}`,
        };
        let newdatas = [...data, newData];
        this.setState({
            data: newdatas,
            total: total + 1,
        });
        const onChange = this.props.onChange;
        if (onChange) {
            // onChange(Object.assign({}, this.state.data, []));
            onChange(Object.assign([], newdatas, []));

        }
    }

    handleSave = (row) => {
        const newData = [...this.state.data];
        const index = newData.findIndex(item => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, {
            ...item,
            ...row,
        });
        this.setState({
            data: newData
        });
        const onChange = this.props.onChange;
        if (onChange) {
            // onChange(Object.assign({}, this.state.data, []));
            onChange(Object.assign([], newData, []));

        }
    }

    render() {
        const { data } = this.state;
        const components = {
            body: {
                row: EditableFormRow,
                cell: EditableCell,
            },
        };
        const columns = this.columns.map((col) => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    editable: col.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: this.handleSave,
                }),
            };
        });
        return (
            <div>
                <Button onClick={this.handleAdd} type="primary" style={{ marginBottom: 16 }}>
                    Add a row
                </Button>
                <Table
                    components={components}
                    rowClassName={() => 'editable-row'}
                    bordered
                    dataSource={data}
                    columns={columns}
                    onChange={this.handleTableChange}
                />
            </div>
        );
    }
}


export class AntTableForm extends React.Component<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            data: []
        }
    }
    render() {
        const { formLayout } = this.props;
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = formLayout === 'horizontal' ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
        } : null;
        return (
            <Form.Item {...formItemLayout} label={this.props.label}>
                {getFieldDecorator(this.props.formKey, {
                    rules: [
                        // {
                        // validator: this.field.validator,
                        // type: this.field.validator, message: 'The input is not valid E-mail!',
                        // type: 'array'
                        // },
                        // {
                        //     required: this.field.required, message: '必填项!',
                        //     type: 'array'
                        // }
                    ],
                })(
                    <AntEditTable></ AntEditTable>
                )}
            </Form.Item>

        )
    }

}
export default AntTableForm

let scheme = {
    key: "test",
    name: "testName",
    props: {},
    children: [
        {
            class: {
                componentTag: "AntInput",
            },
            key: "span",
            name: "占位数",
            props: {
                // span: 6,
                required: true,
                label: "占位数"
            }
        },
        {
            class: {
                componentTag: "AntInput",
            },
            key: "label",
            name: "显示名",
            props: {
                // span: 6,
                label: "显示名"
            }
        },
    ]
}
RegistorClass({
    componentTag: "AntTable",
    componentObject: AntTableForm,
    componentName: "Ant表格",
    scheme: scheme,
    defaultProps: {
        span: 24,
        lable: "Ant表框",
        required: false
    }
})